import { render, staticRenderFns } from "./CardExport.vue?vue&type=template&id=2bb961b5&scoped=true"
import script from "./CardExport.vue?vue&type=script&lang=js"
export * from "./CardExport.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=2bb961b5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb961b5",
  null
  
)

export default component.exports